module.exports = __webpack_public_path__ + "static/media/phone_icon.bf82e1eb.svg";